/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://p42moyea7jgnjm4blgx7nspgtq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4yf56e2wdra3rdpxmw57eqf5qa",
    "aws_cognito_identity_pool_id": "us-east-1:38352e5d-294c-41e7-bddd-47abd46be98e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_M6G5pxHYQ",
    "aws_user_pools_web_client_id": "4l1pvfeli0e3g0vavolakolg45",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "splsysdev235435-ssprod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
